// @flow
export const noopAction = () => ({
  type: 'NOOP_ACTION',
});
